import {
  APP_INITIALIZER,
  EnvironmentProviders,
  makeEnvironmentProviders
} from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { OAuthService } from 'angular-oauth2-oidc';
import { createHubConnection } from './create-hub-connection.function';
import { HubConnectionManager } from './hub-connection-manager.service';

/**
 * Provides the single `signalR.HubConnection` for the sales hub and keeps it in step with the auth
 * session (see HubConnectionManager). Register hub methods on the injected connection; they survive
 * reconnects.
 */
export function provideSignalr(baseUrl: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: signalR.HubConnection,
      useFactory: (oAuthService: OAuthService) =>
        createHubConnection(`${baseUrl}/api/signalr/sales`, oAuthService),
      deps: [OAuthService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (manager: HubConnectionManager) => () => manager.initialize(),
      deps: [HubConnectionManager],
      multi: true,
    },
  ]);
}
